import type { ReactNode } from "react";

/**
 * Mono — a tabular/mono span that stays an LTR island inside RTL layouts (matricules, montants,
 * codes, NIN). Combines the kit's `nv-mono` + `nv-ltr-island` classes.
 */
export function Mono({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={`nv-mono nv-ltr-island${className ? ` ${className}` : ""}`}>{children}</span>;
}
